import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'
import { Link } from 'gatsby'
import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <Showcase
          site={data.site}
          title="Select"
          text={
            <p>
              In addition to the default state, each select component also has
              an active state, a focus state and a selected state. In the active
              state, a dropdown presents input options with their own hover
              states. Once the user selects an option, the dropdown disappears,
              and the selected state appears. The error state takes the form of
              an{' '}
              <Link to="/components/inline-error/develop/" className="c-link">
                Input Error
              </Link>{' '}
              component.{' '}
            </p>
          }
          code={code.checkbox}
        >
          <label for="select-1" class="c-label">
            Label Name
          </label>
          <select class="c-select" id="select-1">
            <option value="">Month</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
          </select>
        </Showcase>
        <SectionTitle>Microcopy</SectionTitle>{' '}
        <p>
          Keep text label and input options on a single line and of similar
          length. All options should use the same part of speech (e.g. all nouns
          or all verbs) rather than mixing. Use sentence case with no end
          punctuation.
        </p>
      </Layout>
    </>
  )
}

export const code = {
  checkbox: `<label for="select-1" class="c-label">
  Label Name
</label>
<select class="c-select" id="select-1">
    <option value="">Select</option>
    <option value="1">One</option>
    <option value="2">Two</option>
    <option value="3">Three</option>
</select>
`,
}
